import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import * as ReactTooltip from "react-tooltip";
import { Button } from "reactstrap";
import { bindActionCreators } from "redux";
import {
    LaboratoryCreateBreadcrumbs,
    LaboratoryDetailsBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import useNavigate from "src/hooks/useNavigate";
import { ILaboratoryReduxFormState } from "src/reducers/reactReduxForms/laboratory";
import * as InstitutionLaboratoryActions from "../../../actions/institutionLaboratory";
import * as LaboratoryActions from "../../../actions/laboratories";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialGroupLaboratoryActions from "../../../actions/trialGroupLaboratory";
import * as TrialInstitutionLaboratoryActions from "../../../actions/trialInstitutionLaboratory";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    DatePickerFormInputFabric,
    SelectFormInput,
    TextAreaFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { LaboratorySubMenu } from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./LabPage.scss";

interface LabPageProps {
    form: Dtos.Laboratory & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ILaboratoryReduxFormState;
    laboratory: Dtos.Laboratory;
    lookups: Dtos.Lookup[];
    loadingLaboratory: boolean;
    loadLaboratorySuccess: boolean;
    loadLaboratoryFailure: boolean;
    loadLaboratoryErrorCode: string;
    savingLaboratory: boolean;
    saveLaboratorySuccess: boolean;
    saveLaboratoryFailure: boolean;
    creatingLaboratory: boolean;
    createLaboratorySuccess: boolean;
    createLaboratoryFailure: boolean;
    validatingLaboratory: boolean;
    validationFailures: Dtos.ResponseError[];
    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    institutionLaboratories: Dtos.InstitutionLaboratory[];
    loadingInstitutionLaboratories: boolean;
    loadInstitutionLaboratoriesSuccess: boolean;
    loadInstitutionLaboratoriesFailure: boolean;
    loadInstitutionLaboratoriesErrorCode: string;
    trialInstitutionLaboratories: Dtos.TrialInstitutionLaboratory[];
    loadingTrialInstitutionLaboratories: boolean;
    loadTrialInstitutionLaboratoriesSuccess: boolean;
    loadTrialInstitutionLaboratoriesFailure: boolean;
    loadTrialInstitutionLaboratoriesErrorCode: string;
    trialGroupLaboratories: Dtos.TrialGroupLaboratory[];
    loadingTrialGroupLaboratories: boolean;
    loadTrialGroupLaboratoriesSuccess: boolean;
    loadTrialGroupLaboratoriesFailure: boolean;
    loadTrialGroupLaboratoriesErrorCode: string;
    clearLaboratory: LaboratoryActions.ILaboratoryClearActionCreator;
    loadLaboratory: LaboratoryActions.ILaboratoryLoadByIdActionCreator;
    saveLaboratory: LaboratoryActions.ILaboratorySaveActionCreator;
    createLaboratory: LaboratoryActions.ILaboratoryCreateActionCreator;
    validateLaboratory: LaboratoryActions.ILaboratoryValidateActionCreator;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
    clearInsitutionLaboratories: InstitutionLaboratoryActions.IInstitutionLaboratoryClearActionCreator;
    loadInstitutionLaboratories: InstitutionLaboratoryActions.IInstitutionLaboratoryLoadByLaboratoryIdActionCreator;
    clearTrialInsitutionLaboratories: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryClearActionCreator;
    loadTrialInstitutionLaboratories: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryLoadByLaboratoryIdActionCreator;
    clearTrialGroupLaboratories: TrialGroupLaboratoryActions.ITrialGroupLaboratoryClearActionCreator;
    loadTrialGroupLaboratories: TrialGroupLaboratoryActions.ITrialGroupLaboratoryLoadByLaboratoryIdActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

}

const reduxFormName: string = "reduxForms.laboratory";

const LabPage: FC<LabPageProps> = ({
    form,
    formState,
    formProperties,
    laboratory,
    lookups,
    loadingLaboratory,
    loadLaboratoryFailure,
    loadLaboratoryErrorCode,
    savingLaboratory,
    saveLaboratorySuccess,
    saveLaboratoryFailure,
    creatingLaboratory,
    validatingLaboratory,
    validationFailures,
    permissions,
    institutionLaboratories,
    loadingInstitutionLaboratories,
    loadInstitutionLaboratoriesFailure,
    loadInstitutionLaboratoriesErrorCode,
    trialInstitutionLaboratories,
    loadingTrialInstitutionLaboratories,
    loadTrialInstitutionLaboratoriesFailure,
    loadTrialInstitutionLaboratoriesErrorCode,
    trialGroupLaboratories,
    loadingTrialGroupLaboratories,
    loadTrialGroupLaboratoriesFailure,
    loadTrialGroupLaboratoriesErrorCode,
    clearLaboratory,
    loadLaboratory,
    saveLaboratory,
    createLaboratory,
    validateLaboratory,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems,
    clearInsitutionLaboratories,
    loadInstitutionLaboratories,
    clearTrialInsitutionLaboratories,
    loadTrialInstitutionLaboratories,
    clearTrialGroupLaboratories,
    loadTrialGroupLaboratories
}) => {
    //
    // -- Params --
    const { laboratoryId } = useParams<{ laboratoryId: string }>();
    const laboratoryIdNumber = parseInt(laboratoryId, 10);

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [activeDisabled, setActiveDisabled] = useState<boolean>(false);
    const [formInitalised, setFormInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();


    // Load Laboratory
    useEffect(() => {
        if (laboratoryIdNumber && !laboratory) {
            setDrawerItems(LaboratorySubMenu(laboratoryIdNumber, permissions));
            setBreadcrumbs(LaboratoryDetailsBreadcrumbs(laboratoryIdNumber));

            loadLaboratory(laboratoryIdNumber);
            loadInstitutionLaboratories(laboratoryIdNumber);
            loadTrialInstitutionLaboratories(laboratoryIdNumber);
            loadTrialGroupLaboratories(laboratoryIdNumber);
        } else if (!laboratoryIdNumber && !laboratory) {
            setBreadcrumbs(LaboratoryCreateBreadcrumbs());
            setDrawerItems([]);
            createLaboratory();
        } else if (laboratory && !formInitalised) {
            loadReduxForm();
            setFormInitalised(true);
        }
    }, [
        laboratoryIdNumber,
        laboratory,
        permissions,
        formInitalised,
        setDrawerItems,
        setBreadcrumbs,
        loadLaboratory,
        loadInstitutionLaboratories,
        loadTrialInstitutionLaboratories,
        loadTrialGroupLaboratories,
        setFormInitalised,
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadLaboratoryFailure) {
            navigate(`/error/${loadLaboratoryErrorCode}`);
        }
        if (loadInstitutionLaboratoriesFailure) {
            navigate(`/error/${loadInstitutionLaboratoriesErrorCode}`);
        }
        if (loadTrialInstitutionLaboratoriesFailure) {
            navigate(`/error/${loadTrialInstitutionLaboratoriesErrorCode}`);
        }
        if (loadTrialGroupLaboratoriesFailure) {
            navigate(`/error/${loadTrialGroupLaboratoriesErrorCode}`);
        }
    }, [
        loadLaboratoryFailure,
        loadInstitutionLaboratoriesFailure,
        loadTrialInstitutionLaboratoriesFailure,
        loadTrialGroupLaboratoriesFailure,
        loadLaboratoryErrorCode,
        loadInstitutionLaboratoriesErrorCode,
        loadTrialInstitutionLaboratoriesErrorCode,
        loadTrialGroupLaboratoriesErrorCode,
        navigate,
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (laboratoryIdNumber && laboratory?.name) {
            setBreadcrumbs(
                LaboratoryDetailsBreadcrumbs(
                    laboratoryIdNumber,
                    laboratory.name
                )
            );
        }
    }, [
        laboratory,
        laboratoryIdNumber,
        permissions,
        setDrawerItems,
        setBreadcrumbs,
    ]);

    // Reload laboratory after saving
    useEffect(() => {
        if (!savingLaboratory && saveLaboratorySuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Laboratory saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(`/labs`);
            } else if (!laboratoryIdNumber) {
                navigate(`/labs/${laboratory.id}/details`);
                clearLaboratory();
            }
        }
    }, [
        savingLaboratory,
        saveLaboratorySuccess,
        loadLaboratory,
        laboratoryIdNumber,
        navigate,
        clearLaboratory,
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingLaboratory && saveLaboratoryFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingLaboratory, saveLaboratorySuccess, loadLaboratory]);

    // Disable the active form button if the lab has active affiliates (date ceased is not null)
    useEffect(() => {
        if (institutionLaboratories && institutionLaboratories?.length > 0) {
            const institutionLaboratoriesCeasedStats = institutionLaboratories
                ?.filter((x) => x.active)
                ?.map((x) => x.active);
            if (institutionLaboratoriesCeasedStats?.length > 0) {
                setActiveDisabled(true);
            }
        }

        if (
            trialInstitutionLaboratories &&
            trialInstitutionLaboratories?.length > 0
        ) {
            const trialInstitutionLaboratoriesCeasedStats =
                trialInstitutionLaboratories
                    ?.filter((x) => x.active)
                    ?.map((x) => x.active);
            if (trialInstitutionLaboratoriesCeasedStats?.length > 0) {
                setActiveDisabled(true);
            }
        }

        if (trialGroupLaboratories && trialGroupLaboratories?.length > 0) {
            const trialGroupLaboratoriesCeasedStats = trialGroupLaboratories
                ?.filter((x) => x.active)
                ?.map((x) => x.active);
            if (trialGroupLaboratoriesCeasedStats?.length > 0) {
                setActiveDisabled(true);
            }
        }
    }, [
        institutionLaboratories,
        trialInstitutionLaboratories,
        trialGroupLaboratories,
        setActiveDisabled,
    ]);

    // Cleanup effect to clear the laboratory on component unmount
    useEffect(() => {
        return () => {
            clearLaboratory();
            clearInsitutionLaboratories();
            clearTrialInsitutionLaboratories();
            clearTrialGroupLaboratories();
            resetForm(reduxFormName);
        };
    }, [
        clearLaboratory,
        clearInsitutionLaboratories,
        clearTrialInsitutionLaboratories,
        clearTrialGroupLaboratories,
        resetForm,
        reduxFormName,
    ]);

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.Laboratory = {} as Dtos.Laboratory;
            if (data.active) {
                changes.dateInactive = null;
            }
            await saveLaboratory(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    const handleOnSubmitFailed = (_data: Dtos.Laboratory) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const onCancel = () => {
        navigate("/labs");
    };

    const loadReduxForm = () => {
        let extraData: Dtos.Laboratory = {} as Dtos.Laboratory;

        loadForm(reduxFormName, Object.assign({ ...laboratory }, extraData));
    };

    const openFile = (link: string) => {
        window.open(`${link}`, "_blank");
        return null;
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.Laboratory = {} as Dtos.Laboratory;

            if (form && hasBeenSubmitted && !validatingLaboratory) {
                await validateLaboratory(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermissionFor(
                undefined,
                laboratoryIdNumber,
                permissions,
                Dtos.Permission.LabUpdate,
                Dtos.Permission.LabCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingLaboratory ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            name: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-4",
                                                fieldClassName:
                                                    "col-sm-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-1 d-flex justify-content-end align-items-center">
                                    <div
                                        data-tip={
                                            "A lab can't be made inactive while actively associated with an institution, trial institution or trial group"
                                        }
                                    >
                                        {activeDisabled && <ReactTooltip />}
                                        {renderFormControls(
                                            form,
                                            "laboratory",
                                            {
                                                active: {
                                                    type: RegistrationComponent.RegistrationControl,
                                                    inputType:
                                                        CheckboxFormInput,
                                                    inputDisabled:
                                                        formDisabled ||
                                                        activeDisabled,
                                                    inputProps: {
                                                        label: "Active, ",
                                                    },
                                                    inputLabel: " ",
                                                    groupClassName:
                                                        "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                    labelClassName:
                                                        "col-form-label col-sm-4 d-none",
                                                    fieldClassName:
                                                        "col-sm-12 generic-form-field d-flex align-items-center",
                                                    changeAction: (
                                                        _model,
                                                        value,
                                                        _form,
                                                        _parentModel
                                                    ) => {
                                                        if (value) {
                                                            changeForm(
                                                                reduxFormName +
                                                                    ".dateCeased",
                                                                null
                                                            );
                                                        }
                                                        changeForm(
                                                            reduxFormName +
                                                                ".active",
                                                            value
                                                        );
                                                    },
                                                },
                                            },
                                            lookups,
                                            validationFailures,
                                            formProperties,
                                            changeForm
                                        )}
                                    </div>
                                </div>
                                <div className="col-5">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            dateInactive: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled:
                                                    formDisabled || form.active,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            abn: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xxl-2",
                                                fieldClassName:
                                                    "col-12 col-xxl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            addressGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Address</h1>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            address: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: { rows: 3 },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            suburb: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-4",
                                                fieldClassName:
                                                    "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            phone: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            stateId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "laboratory",
                                                                "stateId",
                                                                lookups
                                                            ),
                                                            form.stateId
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-4",
                                                fieldClassName:
                                                    "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            facsimileNumber: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            postcode: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-4",
                                                fieldClassName:
                                                    "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            countryId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "laboratory",
                                                                "CountryId",
                                                                lookups
                                                            ),
                                                            form.countryId
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            additionalInformation: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-2 px-4",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            supportingInformation: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Documentation</h1>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-8">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            accreditationCertificate: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-1">
                                    <Button
                                        type="button"
                                        onClick={() => {
                                            openFile(
                                                form.accreditationCertificate
                                            );
                                        }}
                                        disabled={
                                            form?.accreditationCertificate ==
                                            null
                                        }
                                        style={{
                                            cursor:
                                                form?.accreditationCertificate ==
                                                null
                                                    ? "not-allowed"
                                                    : "pointer",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={FontAwesomeIcons.Solid.EYE}
                                        />
                                    </Button>
                                </div>
                                <div className="col-3">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            accreditationNumber: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-8">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            ranges: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-1">
                                    <Button
                                        type="button"
                                        onClick={() => {
                                            openFile(form.ranges);
                                        }}
                                        disabled={form?.ranges == null}
                                        style={{
                                            cursor:
                                                form?.ranges == null
                                                    ? "not-allowed"
                                                    : "pointer",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={FontAwesomeIcons.Solid.EYE}
                                        />
                                    </Button>
                                </div>
                                <div className="col-3">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            yearRange: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-8">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            multiSiteAdvisory: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-1">
                                    <Button
                                        type="button"
                                        onClick={() => {
                                            openFile(form.multiSiteAdvisory);
                                        }}
                                        disabled={
                                            form?.multiSiteAdvisory == null
                                        }
                                        style={{
                                            cursor:
                                                form?.multiSiteAdvisory == null
                                                    ? "not-allowed"
                                                    : "pointer",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={FontAwesomeIcons.Solid.EYE}
                                        />
                                    </Button>
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-8">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            supportingInformation: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-3",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-1">
                                    <Button
                                        type="button"
                                        onClick={() => {
                                            openFile(
                                                form.supportingInformation
                                            );
                                        }}
                                        disabled={
                                            form?.supportingInformation == null
                                        }
                                        style={{
                                            cursor:
                                                form?.supportingInformation ==
                                                null
                                                    ? "not-allowed"
                                                    : "pointer",
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={FontAwesomeIcons.Solid.EYE}
                                        />
                                    </Button>
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "laboratory",
                                        {
                                            comments: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-2 px-4",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "laboratory",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(reduxFormName + ".saveAndReturn", false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={onCancel} className="btn btn-primary mr-2">
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        AuthenticationHelper,
        laboratoryIdNumber,
        permissions,
        savingLaboratory,
        formState,
        handleOnSubmit,
        handleOnSubmitFailed,
        renderFormControls,
        lookups,
        validationFailures,
        formProperties,
        form,
        changeForm,
        reduxFormName,
        onCancel,
        openFile,
        activeDisabled,
    ]);

    return (
        <RestrictedLayout
            permission={Dtos.Permission.LabDetailsView}
            loading={
                loadingLaboratory ||
                creatingLaboratory ||
                savingLaboratory ||
                loadingInstitutionLaboratories ||
                loadingTrialInstitutionLaboratories ||
                loadingTrialGroupLaboratories
            }
        >
            {renderContent}
        </RestrictedLayout>
    );
};

const mapStateToProps = (state: ITmdState): Partial<LabPageProps> => {
    let laboratory: Dtos.Laboratory | undefined = !(
        state.laboratories.formData instanceof Array
    )
        ? state.laboratories.formData
        : undefined;
    let institutionLaboratories: Dtos.InstitutionLaboratory[] | undefined =
        state.institutionLaboratory.formData instanceof Array
            ? state.institutionLaboratory.formData
            : undefined;
    let trialInstitutionLaboratories:
        | Dtos.TrialInstitutionLaboratory[]
        | undefined =
        state.trialInstitutionLaboratory.formData instanceof Array
            ? state.trialInstitutionLaboratory.formData
            : undefined;
    let trialGroupLaboratories: Dtos.TrialGroupLaboratory[] | undefined =
        state.trialGroupLaboratory.formData instanceof Array
            ? state.trialGroupLaboratory.formData
            : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        laboratory: laboratory!,
        loadingLaboratory:
            state.laboratories.loadState &&
            state.laboratories.loadState.status == RequestState.Pending,
        loadLaboratorySuccess:
            state.laboratories.loadState &&
            state.laboratories.loadState.status == RequestState.Success,
        loadLaboratoryFailure:
            state.laboratories.loadState &&
            state.laboratories.loadState.status == RequestState.Failure,
        loadLaboratoryErrorCode: state.laboratories.loadState.errorCode,
        savingLaboratory:
            state.laboratories.saveState &&
            state.laboratories.saveState.status == RequestState.Pending,
        saveLaboratorySuccess:
            state.laboratories.saveState &&
            state.laboratories.saveState.status == RequestState.Success,
        saveLaboratoryFailure:
            state.laboratories.saveState &&
            state.laboratories.saveState.status == RequestState.Failure,
        creatingLaboratory:
            state.laboratories.createState &&
            state.laboratories.createState.status == RequestState.Pending,
        createLaboratorySuccess:
            state.laboratories.createState &&
            state.laboratories.createState.status == RequestState.Success,
        createLaboratoryFailure:
            state.laboratories.createState &&
            state.laboratories.createState.status == RequestState.Failure,
        validatingLaboratory:
            state.laboratories.validateState &&
            state.laboratories.validateState.status == RequestState.Pending,
        user: state.user.data,
        permissions: permissions,
        institutionLaboratories: institutionLaboratories!,
        loadingInstitutionLaboratories:
            state.institutionLaboratory.loadState &&
            state.institutionLaboratory.loadState.status ==
                RequestState.Pending,
        loadInstitutionLaboratoriesSuccess:
            state.institutionLaboratory.loadState &&
            state.institutionLaboratory.loadState.status ==
                RequestState.Success,
        loadInstitutionLaboratoriesFailure:
            state.institutionLaboratory.loadState &&
            state.institutionLaboratory.loadState.status ==
                RequestState.Failure,
        loadInstitutionLaboratoriesErrorCode:
            state.institutionLaboratory.loadState.errorCode,
        trialInstitutionLaboratories: trialInstitutionLaboratories!,
        loadingTrialInstitutionLaboratories:
            state.trialInstitutionLaboratory.loadState &&
            state.trialInstitutionLaboratory.loadState.status ==
                RequestState.Pending,
        loadTrialInstitutionLaboratoriesSuccess:
            state.trialInstitutionLaboratory.loadState &&
            state.trialInstitutionLaboratory.loadState.status ==
                RequestState.Success,
        loadTrialInstitutionLaboratoriesFailure:
            state.trialInstitutionLaboratory.loadState &&
            state.trialInstitutionLaboratory.loadState.status ==
                RequestState.Failure,
        loadTrialInstitutionLaboratoriesErrorCode:
            state.trialInstitutionLaboratory.loadState.errorCode,
        trialGroupLaboratories: trialGroupLaboratories!,
        loadingTrialGroupLaboratories:
            state.trialGroupLaboratory.loadState &&
            state.trialGroupLaboratory.loadState.status == RequestState.Pending,
        loadTrialGroupLaboratoriesSuccess:
            state.trialGroupLaboratory.loadState &&
            state.trialGroupLaboratory.loadState.status == RequestState.Success,
        loadTrialGroupLaboratoriesFailure:
            state.trialGroupLaboratory.loadState &&
            state.trialGroupLaboratory.loadState.status == RequestState.Failure,
        loadTrialGroupLaboratoriesErrorCode:
            state.trialGroupLaboratory.loadState.errorCode,
        lookups: state.laboratories.lookups,
        form: state.reduxForms.laboratory,
        formState: state.laboratories.formState,
        formProperties: state.laboratories.formProperties,
        reduxFormState: state.reduxForms.formState.laboratory,
        validationFailures: laboratory
            ? state.laboratories.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (dispatch): Partial<LabPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadLaboratory: bindActionCreators(
            LaboratoryActions.LoadLaboratoryById,
            dispatch
        ),
        clearLaboratory: bindActionCreators(LaboratoryActions.Clear, dispatch),
        saveLaboratory: bindActionCreators(
            LaboratoryActions.SaveLaboratory,
            dispatch
        ),
        createLaboratory: bindActionCreators(
            LaboratoryActions.CreateLaboratory,
            dispatch
        ),
        validateLaboratory: bindActionCreators(
            LaboratoryActions.ValidateLaboratory,
            dispatch
        ),
        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        ),
        clearInsitutionLaboratories: bindActionCreators(
            InstitutionLaboratoryActions.Clear,
            dispatch
        ),
        loadInstitutionLaboratories: bindActionCreators(
            InstitutionLaboratoryActions.LoadInstitutionLaboratoryByLaboratoryId,
            dispatch
        ),
        clearTrialInsitutionLaboratories: bindActionCreators(
            TrialInstitutionLaboratoryActions.Clear,
            dispatch
        ),
        loadTrialInstitutionLaboratories: bindActionCreators(
            TrialInstitutionLaboratoryActions.LoadTrialInstitutionLaboratoryByLaboratoryId,
            dispatch
        ),
        clearTrialGroupLaboratories: bindActionCreators(
            TrialGroupLaboratoryActions.Clear,
            dispatch
        ),
        loadTrialGroupLaboratories: bindActionCreators(
            TrialGroupLaboratoryActions.LoadTrialGroupLaboratoryByLaboratoryId,
            dispatch
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LabPage);
